export var LookupStrings;
(function (LookupStrings) {
    LookupStrings["LookupNotFound"] = "INVALID LOOKUP LIST";
    LookupStrings["InvalidLookupError"] = "The lookup is unavailable";
})(LookupStrings || (LookupStrings = {}));
export var LookupErrorCode;
(function (LookupErrorCode) {
    LookupErrorCode["UNKNOWN_ERROR"] = "LookupList/UNKNOWN_ERROR";
    LookupErrorCode["DUPLICATE_VALUE"] = "LookupList/DUPLICATE_VALUE";
    LookupErrorCode["INSERTION_FAILED"] = "LookupList/INSERTION_FAILED";
})(LookupErrorCode || (LookupErrorCode = {}));
export var LookupsTestSubject;
(function (LookupsTestSubject) {
    LookupsTestSubject["LookupsListPage"] = "lookup-list-page";
    LookupsTestSubject["LookupsListTable"] = "lookup-list-table";
    LookupsTestSubject["LookupEditPage"] = "lookup-edit-page";
    LookupsTestSubject["LookupEditNameInput"] = "lookup-edit-name";
    LookupsTestSubject["LookupEditDescriptionInput"] = "lookup-edit-description";
    LookupsTestSubject["LookupEditElementValueInput"] = "lookup-element-value";
    LookupsTestSubject["LookupEditElementNoteInput"] = "lookup-element-note";
    LookupsTestSubject["LookupEditElementTTLInput"] = "lookup-element-ttl";
    LookupsTestSubject["LookupEditSubmit"] = "lookup-edit-submit";
    LookupsTestSubject["DynamicLookupEditPage"] = "dlist-edit-page";
    LookupsTestSubject["DynamicLookupCreateButton"] = "dlist-create-button";
    LookupsTestSubject["DynamicEditFieldSelect"] = "dlist-field-select";
    LookupsTestSubject["DynamicEditQuery"] = "dlist-field-query";
    LookupsTestSubject["DynamicTimeframeField"] = "dlist-field-timeframe";
    LookupsTestSubject["DynamicUpdateIntervalField"] = "dlist-field-update-interval";
    LookupsTestSubject["DynamicElasticFilters"] = "dlist-elastic-filters";
    LookupsTestSubject["LookupsUploadCSVButton"] = "lookups-upload-csv-button";
    LookupsTestSubject["LookupUploadModal"] = "lookup-upload-modal";
    LookupsTestSubject["LookupUploadModalSubmitButton"] = "upload-csv-file";
    LookupsTestSubject["LookupUploadModalTTLInput"] = "lookup-modal-ttl-input";
    LookupsTestSubject["LookupUploadModalErrorText"] = "upload-error-text";
    LookupsTestSubject["LookupDefaultTTLValue"] = "lookup-default-ttl-value";
    LookupsTestSubject["LookupDefaultTTLSelect"] = "lookup-default-ttl-select";
    LookupsTestSubject["LookupDefaultTTLSaveButton"] = "lookup-default-ttl-save";
    LookupsTestSubject["LookupDefaultTTLCancelButton"] = "lookup-default-ttl-cancel";
    LookupsTestSubject["LookupDefaultTTLChangeButton"] = "lookup-default-ttl-change";
    LookupsTestSubject["LookupEditElementTable"] = "lookup-elements-table";
    LookupsTestSubject["AddLookupValue"] = "add-lookup-value";
    LookupsTestSubject["DeleteLookupValue"] = "delete-lookup-value";
    LookupsTestSubject["UpdateLookup"] = "update-lookup";
    LookupsTestSubject["CreateLookup"] = "create-lookup";
    LookupsTestSubject["CreateLookupMenu"] = "create-lookup-menu";
    LookupsTestSubject["DeleteLookup"] = "delete-lookup";
    LookupsTestSubject["UploadCSV"] = "upload-csv";
    LookupsTestSubject["CronScheduleTestSubject"] = "cron-schedule-input";
    LookupsTestSubject["DynamicLookupListLoadingHistorySubject"] = "dynamic-lookup-list-loading-history";
})(LookupsTestSubject || (LookupsTestSubject = {}));
export var LookupListTypes;
(function (LookupListTypes) {
    LookupListTypes["DYNAMIC"] = "Dynamic";
    LookupListTypes["STATIC"] = "Static";
})(LookupListTypes || (LookupListTypes = {}));
export var DynamicLookupListLoadingStatus;
(function (DynamicLookupListLoadingStatus) {
    DynamicLookupListLoadingStatus["SUCCESS"] = "Success";
    DynamicLookupListLoadingStatus["TRUNCATED"] = "Truncated";
    DynamicLookupListLoadingStatus["ERROR"] = "Error";
})(DynamicLookupListLoadingStatus || (DynamicLookupListLoadingStatus = {}));
//# sourceMappingURL=lookup.enums.js.map